import React from 'react';
import styled, { css } from 'styled-components';
import { _ } from '_locales';
import { colors } from '_styles';
import images from '_images';

import { Modal } from '../../../components';

// style
const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const TextHeader = styled.legend`
  margin: 0 0 10px 0 !important;
  font-size: 14px !important;
  color: #000000 !important;
  font-weight: 400 !important;
  font-family: Roboto, sans-serif !important;
  width: 100%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Link = styled.a`
  font-size: 14px !important;
  font-weight: 500 !important;

  color: ${colors.RC_ACTION} !important;

  &:hover {
    color: ${colors.RC_ACTION} !important;
    /* text-decoration: none !important; */
  }

  ${(parentWidth < 831) && css`
    flex: 1;
    text-align: center;
  `};

  ${(parentWidth < 341) && css`
    font-size: 12px !important;
    padding-top: 4px !important;
  `};
`;
const LinkSmall = styled(Link)`
  font-size: 12px !important;
  display: inline;
  ${(parentWidth < 430) && css`
    font-size: 8px !important;
  `};
`;
const Ol = styled.ol`
  margin: unset;
  padding-inline-start: 30px;
`;

const ImageLinkContainer = styled.div`
  display: block;
  margin: 2px 0px
`;

const Img = styled.img`
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
  cursor: pointer;
`;

const Button = styled.button`
  background-color: #01288f;
  border: none;
  cursor: pointer;
  border-radius: 7px;
  color: white;
  font-size: 14px !important;
  min-width: 88px;
  min-height: 35px;
  margin: 4px;
`;

const OutlookExportModal = ({
  calendarType,
  handleClose,
}) => {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(calendarType.iCal);
  };

  return (
    <Modal closeModal={handleClose}>
      <Content>
        <TextHeader>{_('cal.please_follow_steps_outlook')}</TextHeader>
        <Ol>
          <li>
            <TextHeader>
              {_('cal.sign_in_to')}
              {' '}
              <Link
                href={calendarType.OutLook}
                target="_blank"
                rel="noreferrer"
                alt="Outlook calendar link"
                style={{ marginLeft: 'auto' }}
              >
                Outlook.com
              </Link>
            </TextHeader>
          </li>
          <li>
            <TextHeader>
              {_('cal.at_the_bottom_of_the_page')}
              <img src={images.calendar.msCalendar} alt="Outlook icon" />
              .
            </TextHeader>
          </li>
          <li>
            <TextHeader>
              {_('cal.in_the_navigation')}
              {' '}
              <strong>
                {_('cal.add_calendar')}
              </strong>
              .
            </TextHeader>
          </li>
          <li>
            <TextHeader>
              {_('cal.select')}
              {' '}
              <strong>
                {_('cal.subscribe_from_web')}
              </strong>
              .
            </TextHeader>
          </li>
          <li>
            <>
              <TextHeader>
                {_('cal.copy_the_below_url')}
                {' '}
              </TextHeader>
              <ImageLinkContainer>
                <Img src={images.calendar.copyLink} alt="Copy icon" onClick={copyToClipboard} />
                <LinkSmall
                  href={calendarType.iCal}
                  target="_blank"
                  rel="noreferrer"
                  alt="Outlook calendar link"
                >
                  {calendarType.iCal}
                </LinkSmall>
              </ImageLinkContainer>
            </>

          </li>
          <li>
            <TextHeader>
              {_('cal.select')}
              {' '}
              <strong>
                {_('cal.import')}
              </strong>
              .
            </TextHeader>
          </li>
        </Ol>
        {' '}
        <TextHeader>
          {_('cal.for_additional_instructions_visit')}
          {' '}
          <Link
            href="https://support.microsoft.com/en-us/office/import-or-subscribe-to-a-calendar-in-outlook-com-or-outlook-on-the-web-cff1429c-5af6-41ec-a5b4-74f2c278e98c"
            target="_blank"
            rel="noreferrer"
            alt="Outlook calendar link"
            style={{ marginLeft: 'auto' }}
          >
            {_('cal.microsoft_support')}
          </Link>
          {' '}
          {' '}

          {_('cal.page')}
          .
        </TextHeader>
        <Button onClick={() => handleClose()} aria-label="confirm">
          {_('general.ok')}
        </Button>
      </Content>
    </Modal>
  );
};

export default OutlookExportModal;
